import { create } from 'zustand';
import { Store } from './store.interface';
import workflowDefinitionCanvasStore, {
	defaultWorkflowDefinitionCanvasStore,
} from './workflowDefinitionCanvasStore/workflowDefinitionCanvasStore';
import workflowCreationMetaDataStore, {
	defaultWorkflowCreationMetaDataStore,
} from './workflowCreationMetaDataStore/workflowCreationMetaDataStore';
import taskTypeListStore, {
	defaultTaskTypeListStore,
} from './taskTypeListStore/taskTypeListStore';
import taskDefinitionStore, {
	defaultTaskDefinitionStore,
} from './taskDefinitionStore/taskDefinitionStore';
import createWorkflowDataStore, {
	defaultCreateWorkflowDataStore,
} from './workflowCreateDataStore/workflowCreateDataStore';
import createWorkflowWizardStepsDataStore, {
	defaultCreateWorkflowWizardStepsDataStore,
} from './workflowWizardStepsDataStore/workflowCreateWizardDataStore';
import workflowCreationCommonInputsStore, {
	defaultWorkflowCreationCommonInputsStore,
} from './workflowCreationCommonInputsStore/workflowCreationCommonInputsStore';
import applicationOperationManagementStore, {
	defaultApplicationOperationManagementStore,
} from './applicationOperationManagementStore/applicationOperationManagementStore';
import attributeManagementStore, {
	defaultAttributeManagementStore,
} from './attributeManagementStore/attributeManagementStore';

export const useStore = create<Store>((set, get, store) => ({
	...workflowDefinitionCanvasStore(set, get, store),
	...workflowCreationMetaDataStore(set, get, store),
	...taskTypeListStore(set, get, store),
	...taskDefinitionStore(set, get, store),
	...createWorkflowDataStore(set, get, store),
	...createWorkflowWizardStepsDataStore(set, get, store),
	...workflowCreationCommonInputsStore(set, get, store),
	...applicationOperationManagementStore(set, get, store),
	...attributeManagementStore(set, get, store),
	resetStore: () => {
		set({
			...defaultWorkflowDefinitionCanvasStore,
			...defaultWorkflowCreationMetaDataStore,
			...defaultTaskTypeListStore,
			...defaultTaskDefinitionStore,
			...defaultCreateWorkflowDataStore,
			...defaultCreateWorkflowWizardStepsDataStore,
			...defaultWorkflowCreationCommonInputsStore,
			...defaultApplicationOperationManagementStore,
			...defaultAttributeManagementStore,
		});
	},
}));
